import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import styled from "@emotion/styled"

import { GatsbyImage } from "gatsby-plugin-image"
import { formatPrice } from "../utils/format-price"
import SimpleBar from 'simplebar-react'
import 'simplebar-react/dist/simplebar.min.css'

const Sliderbar = styled.section`
background: #fff;
min-height: 20vh;
margin: 2.5vh auto 10vh auto;
padding: 3vh 4vw;
padding-top: 0;
overflow-x: scroll;
position: relative;
z-index: 2;
.simplebar-scrollbar::before {
  background-color: rgba(0,0,0,0.33);
}
h1 {
  font-family: 'OpticianSans';
  font-size: 3rem;
  margin-bottom: 2.5%;
  letter-spacing: 1px;
  position: static;
  border: 0;
  color: black;
  @media (max-width: 599px) {
      line-height: .75em;
      padding-top: 2vh;
  }
}

div.prodslide {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    align-items: flex-start;
    padding-bottom: 20px;
    > div {
        margin-right: 3vw;
        flex: 0 0 auto;
        text-align: center;
    }
}
`
const Product = styled.div`
    width: 300px;
`

const Shopbar = () => {
    
    const data = useStaticQuery(graphql`
    query {
        products: shopifyCollection(handle: {in: ["gutsy-radio"]}) {
          products {
            id
            title
            slug: gatsbyPath(
            filePath: "/shop/{ShopifyProduct.productType}/{ShopifyProduct.handle}"
              )
           media {
            ... on ShopifyMediaImage {
              id
              image {
                gatsbyImageData(aspectRatio: 1, width: 640)
              }
            }
          }
          priceRangeV2 {
            minVariantPrice {
              amount
              currencyCode
            }
          }
          vendor
          }
        }
      }
    `)
    return (
        <Sliderbar>
          <h1>Gutsy Merch</h1>
          <SimpleBar autoHide={false}>
            <div className="prodslide">
                {data.products.products.map( product => (
                    <Product key={product.id}>
                      <Link to={product.slug}>
                        <GatsbyImage
                        image={product.media[0].image.gatsbyImageData}
                        loading={"lazy"}
                        />
                        <h3>{product.title}</h3>
                    {formatPrice(
                        product.priceRangeV2.minVariantPrice.currencyCode,
                        product.priceRangeV2.minVariantPrice.amount
                    )}
                      </Link>
                    </Product>
                ))}
            </div>
          </SimpleBar>
        </Sliderbar>
    )
}

export default Shopbar